module.exports = __webpack_public_path__ + "static/media/template-products-fashion.19c42084.csv";